export const DEVICE_LIST_SUCCESS = "DEVICE_LIST_SUCCESS";
export const DEVICE_LIST_FAIL = "DEVICE_LIST_FAIL";
export const DEVICE_ADD_SUCCESS = "DEVICE_ADD_SUCCESS";
export const DEVICE_ADD_FAIL = "DEVICE_ADD_FAIL";
export const DEVICE_DELETE_SUCCESS = "DEVICE_DELETE_SUCCESS";
export const DEVICE_DELETE_FAIL = "DEVICE_DELETE_FAIL";
export const DEVICE_INFO_SUCCESS = "DEVICE_INFO_SUCCESS";
export const DEVICE_INFO_FAIL = "DEVICE_INFO_FAIL";
export const ADAPTER_ASSET_LIST_SUCCESS = "ADAPTER_ASSET_LIST_SUCCESS";
export const ADAPTER_ASSET_LIST_FAIL = "ADAPTER_ASSET_LIST_FAIL";
export const ADAPTER_ASSET_INFO_SUCCESS = "ADAPTER_ASSET_INFO_SUCCESS";
export const ADAPTER_ASSET_INFO_FAIL = "ADAPTER_ASSET_INFO_FAIL";
export const ADAPTER_ASSET_DELETE_SUCCESS = "ADAPTER_ASSET_DELETE_SUCCESS";
export const ADAPTER_ASSET_DELETE_FAIL = "ADAPTER_ASSET_DELETE_FAIL";
export const DEVICE_STOLEN_STATUS_SUCCESS = "DEVICE_STOLEN_STATUS_SUCCESS";
export const DEVICE_STOLEN_STATUS_FAIL = "DEVICE_STOLEN_STATUS_FAIL";
export const DEVICE_LOCK_STATUS_SUCCESS = "DEVICE_LOCK_STATUS_SUCCESS";
export const DEVICE_LOCK_STATUS_FAIL = "DEVICE_LOCK_STATUS_FAIL";
export const RESET_DEVICE_DETAILS = "RESET_DEVICE_DETAILS";
export const RESET_ADAPTER_ASSET_DETAILS = "RESET_ADAPTER_ASSET_DETAILS";
export const STORE_DEVICE_DETAILS = "STORE_DEVICE_DETAILS";
export const DEVICE_TYPE_LIST_SUCCESS = "DEVICE_TYPE_LIST_SUCCESS";
export const DEVICE_TYPE_LIST_FAIL = "DEVICE_TYPE_LIST_FAIL";
export const DEVICE_CREATE_RMA_SUCCESS = "DEVICE_CREATE_RMA_SUCCESS";
export const DEVICE_CREATE_RMA_FAIL = "DEVICE_CREATE_RMA_FAIL";
export const DEVICE_RESET_PIN_SUCCESS = "DEVICE_RESET_PIN_SUCCESS";
export const DEVICE_RESET_PIN_FAIL = "DEVICE_RESET_PIN_FAIL";

export const defaultDeviceState = {
  devices: null,
  device: null,
  deviceTypes: null,
  adapterAssets: null,
  adapterAsset: null
};
export default (state = defaultDeviceState, action) => {
  switch (action.type) {
    case DEVICE_LIST_SUCCESS:
      return {
        ...state,
        devices: action.payload.data
      };
    case DEVICE_LIST_FAIL:
      return {
        ...state
      };
    case DEVICE_ADD_SUCCESS:
      return {
        ...state
      };
    case DEVICE_ADD_FAIL:
      return {
        ...state
      };
    case DEVICE_DELETE_SUCCESS:
      return {
        ...state
      };
    case DEVICE_DELETE_FAIL:
      return {
        ...state
      };
    case DEVICE_INFO_SUCCESS:
      return {
        ...state,
        device: action.payload.data
      };
    case DEVICE_INFO_FAIL:
      return {
        ...state
      };
    case ADAPTER_ASSET_LIST_SUCCESS:
      return {
        ...state,
        adapterAssets: action.payload.data
      };
    case ADAPTER_ASSET_LIST_FAIL:
      return {
        ...state,
        adapterAssets: {
          success: false,
          count: 0,
          data: []
        }
      };
    case ADAPTER_ASSET_INFO_SUCCESS:
      return {
        ...state,
        adapterAsset: action.payload.data
      };
    case ADAPTER_ASSET_INFO_FAIL:
      return {
        ...state,
        adapterAsset: null
      };
    case ADAPTER_ASSET_DELETE_SUCCESS:
    case ADAPTER_ASSET_DELETE_FAIL:
      return {
        ...state
      };
    case DEVICE_RESET_PIN_SUCCESS:
    case DEVICE_RESET_PIN_FAIL:
    case DEVICE_STOLEN_STATUS_SUCCESS:
    case DEVICE_STOLEN_STATUS_FAIL:
    case DEVICE_LOCK_STATUS_SUCCESS:
    case DEVICE_LOCK_STATUS_FAIL: {
      return {
        ...state
      };
    }
    case STORE_DEVICE_DETAILS: {
      return {
        ...state,
        device: action.payload
      };
    }
    case RESET_DEVICE_DETAILS: {
      return {
        ...state,
        device: {}
      };
    }
    case RESET_ADAPTER_ASSET_DETAILS: {
      return {
        ...state,
        adapterAsset: null
      };
    }
    case DEVICE_TYPE_LIST_SUCCESS:
      return {
        ...state,
        deviceTypes: action.payload.data
      };
    case DEVICE_TYPE_LIST_FAIL: {
      return {
        ...state
      };
    }
    case DEVICE_CREATE_RMA_SUCCESS:
      return {
        ...state
      };
    case DEVICE_CREATE_RMA_FAIL:
      return {
        ...state
      };
    default:
      return {
        ...state
      };
  }
};
